(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/joker.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/joker.js');


'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const baseJokerPrice = 10;
const jokerPrices = [0, 10, 20, 30];
const jokerNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
const jokerRowSize = 7;
const winConditions = [{
  numbers: 2
}];
const topWins = {
  0: 0,
  10: 10000000,
  20: 20000000,
  30: 30000000
};
const getRowPrice = () => baseJokerPrice;
const getJokerPrices = () => jokerPrices;
const getTopWin = function () {
  let jokerPrice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : baseJokerPrice;
  return topWins[jokerPrice];
};
const isValidRow = row => {
  if (Array.isArray(row)) {
    row = row.map(num => {
      var _num$number;
      return (_num$number = num.number) !== null && _num$number !== void 0 ? _num$number : num;
    }).join('');
  }
  return new RegExp("^[0-9]{".concat(jokerRowSize, "}$")).test(row);
};
const joker = {
  isValidRow,
  getRowPrice,
  getJokerPrices,
  getTopWin,
  winConditions
};

const getHuxfluxedRow = () => {
  var _svsRandom, _svsRandom$getRandomS;
  return (_svsRandom = svsRandom) === null || _svsRandom === void 0 || (_svsRandom$getRandomS = _svsRandom.getRandomSample) === null || _svsRandom$getRandomS === void 0 ? void 0 : _svsRandom$getRandomS.call(_svsRandom, jokerNumbers, jokerRowSize).map(number => ({
    number,
    manual: false
  }));
};
if (svs.isServer) {
  module.exports = {
    joker
  };
} else {
  Object.assign(svs.numbergames.rules, {
    joker: _objectSpread(_objectSpread({}, joker), {}, {
      getHuxfluxedRow
    })
  });
}

 })(window);